import styled from "@emotion/styled";
import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

const StyledBox = styled(Box)(({ theme, isTourActive }) => ({
  minHeight: "100%",
  width: "100%",
  backgroundColor: "#7285b3",
  overflowY: isTourActive ? "hidden" : "visible",
  overflowX: "hidden",
}));

export const ParentPageWrapper = (props) => {
  const tourRun = useSelector((state) => state.mainReducer?.tourRun);
  return <StyledBox isTourActive={!!tourRun}>{props.children}</StyledBox>;
};
